import { render, staticRenderFns } from "./LeftSidebar.vue?vue&type=template&id=1d4a3af7&scoped=true&"
import script from "./LeftSidebar.vue?vue&type=script&lang=js&"
export * from "./LeftSidebar.vue?vue&type=script&lang=js&"
import style0 from "./LeftSidebar.vue?vue&type=style&index=0&id=1d4a3af7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d4a3af7",
  null
  
)

export default component.exports